import { validate } from '@krugom/validator';

const setThrow = (arg?: any) => {
  const scheme = {
    type: 'string',
    required: true,
    pattern: /^\d+$/,
  };
  const result = validate(arg, scheme);

  if (result.isValid) throw new Error(arg);
};
export default setThrow;
